import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from 'src/app/base.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  // Provider = JSON.parse(localStorage.getItem('get_provider'));
  Provider 
  // = JSON.parse(localStorage.getItem('get_provider'));
  currentLanguage = localStorage.getItem('currentLanguage');
  social 
  // = JSON.parse(this.Provider.social);
  logo 
  // = this.Provider.logo;
  user
  file_url = this.BaseService.file_url;
  Providerdescription 
  // = JSON.parse(this.Provider.description);
  description;
  constructor( private BaseService :BaseService ,public translate: TranslateService) {
    console.log(this.logo)
    console.log(this.social);
    if(localStorage.getItem('user')){
       
      this.user = JSON.parse(localStorage.getItem('user')).user
      // this.logo  =  = this.Provider.logo;
    }
    if(localStorage.getItem('get_provider')){
      this.Provider= JSON.parse(localStorage.getItem('get_provider'));
      this.logo  =  this.Provider. logo
      this.social  = JSON.parse(this.Provider.social);
      this.Providerdescription     = JSON.parse(this.Provider.description);
    }
    this.translate.use(this.currentLanguage);
   }

  ngOnInit(): void {
    console.log(this.Providerdescription);
    if(this.currentLanguage == 'ar'){
      this.description = this.Providerdescription.ar;
      console.log( 'description',this.description);
    }
    else if(this.currentLanguage == 'en'){
      this.description = this.Providerdescription.en;
      console.log('description',this.description);
    }
    else if(this.currentLanguage == 'tr'){
      this.description = this.Providerdescription.tr;
      console.log('description',this.description);
    }
  }

}
